<template>
  <a-drawer
    :title="title"
    :width="720"
    :mask-closable="false"
    :wrap-style="{
      height: 'calc(100% - 108px)',
      overflow: 'auto',
    }"
    :visible="accountVisible"
    @close="$emit('onCancel')"
  >
    <a-form
      :form="form"
      :hide-required-mark="false"
      layout="vertical"
    >
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="账户角色">
            <a-select
              v-decorator="[
                'role',
                { rules: [{ required: true, message: '请选择账户角色' }] },
              ]"
              placeholder="请选择账户角色"
              @select="selectRole"
            >
              <a-select-option value="0">
                企业
              </a-select-option>
              <a-select-option value="1">
                服务商
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="所属单位">
            <a-select
              v-decorator="[
                'company_id',
                {
                  rules: [{ required: true, message: '请选择所属单位' }],
                },
              ]"
              placeholder="请选择所属单位"
              :disabled="companyDisabled"
            >
              <a-select-option
                v-for="item in numberData"
                :key="item.id"
                :value="item.id"
              >
                {{ item.team_name?item.team_name:item.companyInfo.qichacha_name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="姓名">
            <a-input
              v-decorator="[
                'real_name',
                {
                  rules: [{ required: true, message: '请输入姓名' }],
                },
              ]"
              placeholder="请输入姓名"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="手机号">
            <a-input
              v-decorator="[
                'phone',
                {
                  rules: [
                    { required: true, message: '请输入手机号码' },
                    {
                      pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                      message: '请输入正确的手机号码',
                    },
                  ],
                },
              ]"
              placeholder="请输入手机号码"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="密码">
            <a-input
              v-decorator="[
                'pwd_new',
                {
                  rules: [{ required: true, message: '请输入密码' }],
                },
              ]"
              placeholder="请输入密码"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="省份">
            <a-select
              v-decorator="[
                'province',
                {
                  rules: [{ required: true, message: '请选择省份' }],
                },
              ]"
              placeholder="请选择省份"
              @select="handleSelect"
            >
              <a-select-option
                v-for="item in provinceData"
                :key="item.id"
                :value="item.id"
              >
                {{ item.title }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="城市">
            <a-select
              v-decorator="[
                'city',
                {
                  rules: [{ required: true, message: '请选择城市' }],
                },
              ]"
              placeholder="请选择城市"
            >
              <a-spin
                v-if="cityLoading"
                slot="notFoundContent"
                size="small"
              />
              <a-select-option
                v-for="item in cityData"
                v-else
                :key="item.id"
                :value="item.id"
              >
                {{ item.title }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="地址">
            <a-input
              v-decorator="['address']"
              placeholder="请输入详细地址"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div
      :style="{
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
      }"
    >
      <a-button
        :style="{ marginRight: '8px' }"
        @click="$emit('onCancel')"
      >
        取消
      </a-button>
      <a-button
        :loading="btnIsLoading"
        type="primary"
        @click="$emit('handleSubmit')"
      >
        确定
      </a-button>
    </div>
  </a-drawer>
</template>
<script>
import { formData1 } from '../data/index';
export default {
  props: ['accountVisible', 'title', 'btnIsLoading'],
  data() {
    return {
      formData1,
      cityLoading: true,
      provinceData: [],
      cityData: [],
      numberData: [],
      companyDisabled: true,
      form: this.$form.createForm(this),
    };
  },
  async mounted() {
    // 获取省市
    let result = await this.$http.post('/system/getRegionList');
    if (result.data.status === 1) {
      this.provinceData = result.data.data;
    }
  },

  methods: {
    // 选择角色
    async selectRole(value) {
      let url =
        value === '0'
          ? '/company/getCompanyList'
          : '/ServiceProvider/getCompanyList';
      let result = await this.$http.post(url, {
        type: '0',
        page: '0',
        pageSize: '0',
      });
      if (result.data.status === 1) {
        console.log(result);
        this.numberData = result.data.data.data_list.filter((item)=>item.status===1);
        this.companyDisabled = false;
      }
    },
    // 选中省份
    async handleSelect(key) {
      this.city = '';
      let result = await this.$http.post('/system/getRegionList', {
        pid: key,
      });
      if (result.data.status === 1) {
        this.cityLoading = false;
        this.cityData = result.data.data;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }
}
</style>
